import C from "@/components/ContentPane.module.css";

import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { PropsWithChildren } from "react";

/** Standard wrapper for page content that eg. adds suitable padding */
export function ContentPane({ children, ...props }: PropsWithChildren<BaseProps>) {
    return <div {...mcn(C.ContentPane, props)}>{children}</div>;
}
